import { useContext } from "react";
import { NotifyContextValue } from "../Context/Notify/interface";
import { NotifyContext } from "../Context/Notify/NotifyContext";

export const useNotify = (): NotifyContextValue => {
  return useContext(NotifyContext);
};
